import {ScrollView} from 'react-native';
import sy from '~/styles';
import {EditDialog as GroupingRowEdit} from '~/components/controls/3/Grouping';
import DiscountIcon from '~/images/md-icons/discount/materialsymbolsoutlined/24px.svg';

const InvoiceAdjustmentDetails = ({
  dimensions,
  title,
  children,
  headerHeight = 64,
  footerHeight = 51,
  visible,
  onClose,
}) => (
  <GroupingRowEdit
    visible={visible}
    onClose={onClose}
    title={title}
    titleIcon={<DiscountIcon fill="#4a4a49" />}
    titleStyle={[sy['ml-4'], sy['mr-4']]}
  >
    <ScrollView
      contentContainerStyle={{
        maxHeight: dimensions.window.height - headerHeight - footerHeight,
      }}
    >
      {children}
    </ScrollView>
  </GroupingRowEdit>
);
// Grouping rows must recognize this wrapper and control its dialog state.
InvoiceAdjustmentDetails.isGroupingEditDialog = true;
export default InvoiceAdjustmentDetails;
